<div class="design-banner-text-div">
    <button *ngIf="!this.IsEditing" mat-raised-button class="button-primary" (click)="this.editClicked()">
        Edit Banner Text
    </button>

    <div *ngIf="this.IsEditing">
        <div class="fields-row">
            <div class="field-margin">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Left Banner Text</mat-label>
                    <input matInput [(ngModel)]="this.leftText" type="text" />
                </mat-form-field>
            </div>
            <div class="field-margin">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Center Banner Text</mat-label>
                    <input matInput [(ngModel)]="this.centerText" type="text" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Right Banner Text</mat-label>
                    <input matInput [(ngModel)]="this.rightText" type="text" />
                </mat-form-field>
            </div>
        </div>


        <div class="fields-row">
            <div class="field-margin">
                <mat-form-field appearance="outline" class="color-mat-field">
                    <mat-label>Banner Text Color</mat-label>
                    <mat-select [(ngModel)]="this.textColor">
                        <mat-option *ngFor="let color of colors" [value]="color.value" title="{{color.name}}">
                            <div class="color-option">
                                <div class="color-box-styling">
                                    <div class="color-box" [ngStyle]="{'background-color':color.value}">
                                    </div>
                                </div>
                                {{color.name}}
                            </div>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="outline" class="color-mat-field">
                    <mat-label>Banner Background Color</mat-label>
                    <mat-select [(ngModel)]="this.backgroundColor">
                        <mat-option *ngFor="let color of colors" [value]="color.value" title="{{color.name}}">
                            <div class="color-option">
                                <div class="color-box-styling">
                                    <div class="color-box" [ngStyle]="{'background-color':color.value}">
                                    </div>
                                </div>
                                {{color.name}}
                            </div>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>


        <div class="center-save-button">
            <button mat-raised-button color="primary" (click)="this.saveClicked()">
                Save
            </button>
        </div>
    </div>
</div>
